import { TextField, Box, InputAdornment } from "@mui/material"
import SearchIcon from "@mui/icons-material/Search"
import { useRef, useEffect } from "react"

export default function SearchBar({
    value,
    onChange,
    placeholder = "Search...",
}) {
    const inputRef = useRef(null)
    const userScrolling = useRef(false)

    useEffect(() => {
        const input = inputRef.current?.querySelector("input")

        // User-initiated scrolls always produce touchmove or wheel events;
        // the browser's auto-scroll-into-view on focus does not.
        const markUserScroll = () => {
            userScrolling.current = true
        }

        // Reset the flag when the input gains focus, before any auto-scroll fires
        const handleFocus = () => {
            userScrolling.current = false
        }

        const handleScroll = () => {
            if (!userScrolling.current) return

            if (input && document.activeElement === input) {
                input.blur()
            }
        }

        input?.addEventListener("focus", handleFocus)
        window.addEventListener("touchmove", markUserScroll, { passive: true })
        window.addEventListener("wheel", markUserScroll, { passive: true })
        window.addEventListener("scroll", handleScroll, { passive: true })

        return () => {
            input?.removeEventListener("focus", handleFocus)
            window.removeEventListener("touchmove", markUserScroll)
            window.removeEventListener("wheel", markUserScroll)
            window.removeEventListener("scroll", handleScroll)
        }
    }, [])

    return (
        <Box
            sx={{
                mt: 2,
                mb: 2,
                // width: '100%',
                display: "flex",
                justifyContent: "center",
            }}
        >
            <TextField
                ref={inputRef}
                value={value}
                onChange={onChange}
                variant="outlined"
                placeholder={placeholder}
                autoComplete="off"
                size="small"
                sx={{
                    "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderRadius: "20px" },
                    },
                }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                }}
            />
        </Box>
    )
}
